import { __assign, __rest } from "tslib";
import React from 'react';
import { Orientation } from '../types';
import { getTextAnchor, getVerticalPosition, getHorizontalPosition, } from './axis-title.utils';
var AxisTitle = function (_a) {
    var children = _a.children, orientation = _a.orientation, line = _a.line, groupBox = _a.groupBox, titleSettings = _a.titleSettings;
    var alignment = titleSettings.alignment, typography = titleSettings.typography, padding = titleSettings.padding;
    var fontColor = typography.fontColor, typographyProps = __rest(typography, ["fontColor"]);
    var x = groupBox.x, y = groupBox.y, height = groupBox.height;
    var textSettings = {
        textAnchor: getTextAnchor(alignment),
        fill: fontColor || 'currentColor',
        x: orientation === Orientation.HORIZONTAL
            ? getHorizontalPosition(alignment, line)
            : getVerticalPosition(alignment, line),
        y: orientation === Orientation.HORIZONTAL
            ? y + height + padding
            : x - padding,
        style: orientation === Orientation.HORIZONTAL
            ? {}
            : {
                transform: 'rotate(-90deg)',
            },
    };
    return (React.createElement("text", __assign({}, textSettings, typographyProps, { "data-elementid": orientation + "-axis-title" }), children));
};
export default AxisTitle;
